var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { eager: "", width: "800" },
      model: {
        value: _vm.openDialog,
        callback: function($$v) {
          _vm.openDialog = $$v
        },
        expression: "openDialog"
      }
    },
    [
      _c(
        "v-card",
        [
          _c(
            "v-toolbar",
            {
              attrs: { color: "yellow darken-3", flat: "", dark: "", dense: "" }
            },
            [_c("span", [_vm._v("Edit")])]
          ),
          _c(
            "v-container",
            [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "4" } },
                    [
                      _c("v-autocomplete", {
                        attrs: {
                          items: _vm.stockList,
                          loading: !_vm.stockList.length,
                          "item-value": "id",
                          label: "Stock",
                          "item-text": "description",
                          filter: _vm.filterStockAutocomplete,
                          "error-messages":
                            _vm.orderDetailUpdatePutErrors.stock_id
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "selection",
                            fn: function({ item }) {
                              return [
                                _c(
                                  "span",
                                  { staticClass: "primary--text mr-2" },
                                  [_vm._v(_vm._s(item.id))]
                                )
                              ]
                            }
                          },
                          {
                            key: "item",
                            fn: function({ item }) {
                              return [
                                _c(
                                  "span",
                                  { staticClass: "primary--text mr-2" },
                                  [_vm._v(_vm._s(item.id))]
                                ),
                                _c(
                                  "small",
                                  { staticClass: "blue-grey--text" },
                                  [_vm._v(_vm._s(item.description))]
                                )
                              ]
                            }
                          }
                        ]),
                        model: {
                          value: _vm.stockId,
                          callback: function($$v) {
                            _vm.stockId = $$v
                          },
                          expression: "stockId"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "4" } },
                    [
                      _c("v-autocomplete", {
                        attrs: {
                          items: _vm.statuses,
                          loading: !_vm.statuses.length,
                          "item-value": "id",
                          "item-text": "name",
                          label: "Status",
                          "error-messages":
                            _vm.orderDetailUpdatePutErrors
                              .order_detail_status_id
                        },
                        model: {
                          value: _vm.orderDetailStatusId,
                          callback: function($$v) {
                            _vm.orderDetailStatusId = $$v
                          },
                          expression: "orderDetailStatusId"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "4" } },
                    [
                      _c("v-autocomplete", {
                        attrs: {
                          label: "Unit",
                          items: _vm.units,
                          "error-messages": _vm.orderDetailUpdatePutErrors.unit
                        },
                        model: {
                          value: _vm.unit,
                          callback: function($$v) {
                            _vm.unit = $$v
                          },
                          expression: "unit"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "4" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          label: "Quantity",
                          type: "number",
                          "error-messages":
                            _vm.orderDetailUpdatePutErrors.quantity
                        },
                        model: {
                          value: _vm.quantity,
                          callback: function($$v) {
                            _vm.quantity = _vm._n($$v)
                          },
                          expression: "quantity"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "4" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          label: "SRP",
                          "error-messages":
                            _vm.orderDetailUpdatePutErrors.unit_price
                        },
                        model: {
                          value: _vm.unitPrice,
                          callback: function($$v) {
                            _vm.unitPrice = $$v
                          },
                          expression: "unitPrice"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "4" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          label: "Discount",
                          "error-messages":
                            _vm.orderDetailUpdatePutErrors.quantity
                        },
                        model: {
                          value: _vm.discount,
                          callback: function($$v) {
                            _vm.discount = $$v
                          },
                          expression: "discount"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "4" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          label: "Date Allocated",
                          type: "date",
                          "error-messages":
                            _vm.orderDetailUpdatePutErrors.date_allocated
                        },
                        model: {
                          value: _vm.dateAllocated,
                          callback: function($$v) {
                            _vm.dateAllocated = $$v
                          },
                          expression: "dateAllocated"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "3" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "yellow darken-2",
                            dense: "",
                            block: "",
                            loading: _vm.orderDetailUpdatePutting,
                            dark: ""
                          },
                          on: { click: _vm.update }
                        },
                        [_c("span", [_vm._v("update")])]
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "3" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "red",
                            dense: "",
                            block: "",
                            dark: ""
                          },
                          on: {
                            click: function($event) {
                              _vm.openDialog = false
                            }
                          }
                        },
                        [_c("span", [_vm._v("cancel")])]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }